import React from "react";

const ViteIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14.5 3L22 12l-7.5 9-7.5-9 1.5-1.5 6 7.5-6 7.5L5 12l9.5-9z" />
  </svg>
);

export default ViteIcon;
